import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import { LocStr } from '../../../utils/Utils';
import { no_str, yes_str } from '../../../utils/DictionaryManagementUtils';

//= ========================================================================
const QuestionButton = ({
  isHallow,
  onPress,
  leftButtonText = no_str,
  rightButtonText = yes_str,
  smallButton,
  language,
  marginRight = 40,
}) => {
  const myStyle = {
    button: {
      fontFamily: 'Rubik-Medium',
      fontSize: 18,
      textAlign: 'center',
      color: isHallow ? '#008cff' : '#fff',
      marginTop: 14,
      minWidth: smallButton ? 80 : 140,
    },
    backgroundButton: {
      minWidth: smallButton ? 80 : 140,
      height: 50,
      marginRight,
      backgroundColor: isHallow ? '#fff' : '#008cff',
      border: isHallow ? 'solid 2px #cbd5e0' : '#008cff',
      borderRadius: 4,
      paddingHorizontal: 20,
    },
  };
  return (
    <TouchableOpacity
      style={myStyle.backgroundButton}
      onPress={onPress}
    >
      <Text style={myStyle.button}>{isHallow ? LocStr(leftButtonText, language) : LocStr(rightButtonText, language)}</Text>
    </TouchableOpacity>
  );
};

export default QuestionButton;
